import React from 'react'
import { Container, Img, Subtitle, TextContainer, Title } from './styles'

interface Props {
  icon: React.ReactNode
  title: string
  subtitle: string
  onClick?: () => void
  showBorder?: boolean
  style?: React.CSSProperties
}

export const Item = ({ icon, title, subtitle, onClick, showBorder, style }: Props) => {
  return (
    <Container $showBorder={showBorder} onClick={onClick} style={style}>
      <Img>{icon}</Img>

      <TextContainer>
        <Title>{title}</Title>
        <Subtitle>{subtitle}</Subtitle>
      </TextContainer>
    </Container>
  )
}
